import { DevToolProviderToken } from '@core/shared/dev-tools';
import { BaseFeature, FeatureType } from '@core/shared/feature';
export class CoreBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@core/feature","featureId":"common-core"},
      abilityActions: false,
      plugins: [{
        forPlatform: 'frontend',
        importFrom: 'frontend-shared',
        type: FeatureType.Permanent,
        pluginClassName: 'CoreFrontendSharedFeature'
      }, {
        forPlatform: 'frontend',
        importFrom: 'frontend-management',
        type: FeatureType.Permanent,
        pluginClassName: 'CoreFrontendManagementFeature'
      },
      // {forPlatform:'admin', importFrom:'frontend-admin', type:FeatureType.Permanent, pluginClassName:'CoreFrontendAdminFeature'},
      {
        forPlatform: 'admin',
        importFrom: 'frontend-shared',
        type: FeatureType.Permanent,
        pluginClassName: 'CoreFrontendSharedFeature'
      }, {
        forPlatform: 'backend',
        importFrom: 'backend',
        type: FeatureType.Permanent,
        pluginClassName: 'CoreBackendFeature'
      }],
      providers: [{
        token: DevToolProviderToken,
        forPlatform: 'frontend',
        providerName: 'clientCacheDevToolProvider',
        importFrom: 'frontend-shared'
      }, {
        token: DevToolProviderToken,
        forPlatform: 'admin',
        providerName: 'clientCacheDevToolProvider',
        importFrom: 'frontend-shared'
      }, {
        token: DevToolProviderToken,
        forPlatform: 'frontend',
        providerName: 'modelMetadataDevToolDefinition',
        importFrom: 'frontend-shared'
      }, {
        token: DevToolProviderToken,
        forPlatform: 'admin',
        providerName: 'modelMetadataDevToolDefinition',
        importFrom: 'frontend-shared'
      }, {
        token: DevToolProviderToken,
        forPlatform: 'frontend',
        providerName: 'storeInspectorDevToolDefinition',
        importFrom: 'frontend-shared'
      }, {
        token: DevToolProviderToken,
        forPlatform: 'admin',
        providerName: 'storeInspectorDevToolDefinition',
        importFrom: 'frontend-shared'
      }]
    };
  }
  getSharedDefinition() {
    const errorResolvers = {
      'error': () => '/error',
      'error-0': () => '/error/0',
      'error-403': () => '/error/403',
      'error-router': () => '/error/router'
    };
    return {
      routerLinkResolvers: {
        frontend: {
          ...errorResolvers,
          management: () => '/management',
          'begin-session-by-url': data => {
            if (data.sessionId && data.loginByLinkSecret) {
              return `/auth/begin-session-by-url?sessionId=${data.sessionId}&loginByLinkSecret=${data.loginByLinkSecret}`;
            } else return '/auth/begin-session-by-url';
          }
        },
        admin: errorResolvers
      }
    };
  }
}